import type { AuthAccountInfo } from '../entities/session';
import { useCachedUserAvatarUrl } from './use-cached-user-avatar-url';

export function useCachedOwnAvatarUrl(
  account: AuthAccountInfo | null | undefined
): string | null | undefined {
  return useCachedUserAvatarUrl({
    userId: account?.id,
    avatarUrl: account?.avatar,
    scopeAccountId: account?.id,
  });
}
